// Unread Exam Data - start
export const FETCH_UNREAD_EXAM_DATA_REQUEST = 'FETCH_UNREAD_EXAM_DATA_REQUEST';
export const FETCH_UNREAD_EXAM_DATA_SUCCESS = 'FETCH_UNREAD_EXAM_DATA_SUCCESS';
export const FETCH_UNREAD_EXAM_DATA_FAILURE = 'FETCH_UNREAD_EXAM_DATA_FAILURE';
// Unread Exam Data - end